module.exports =
  bindings:
    scheduleBreak: '<'
    showTypeFlags: '<'
    salon: '<'
    onSubmit: '&?'
  template: require('./index.pug')()
  controller: require('./index.ctrl')
